const defaultHeaderHeight = 120;

export const getHeaderHeight = (): number => {
  const header = document.getElementById('header');
  const headerRect = header?.getBoundingClientRect();

  return (headerRect?.height || defaultHeaderHeight);
};
